// extracted by mini-css-extract-plugin
export default {"component":"IntroductionLinks__component___FzdP0","linksContainer":"IntroductionLinks__linksContainer___RjdBl"};